import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { Body, H5 } from 'syf-component-library/ui/typography';
export const StatusMessageContainer = styled(Inset) `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-inline: auto;

  @media ${query.lessThanSmall} {
    width: 90%;
  }
`;
export const Image = styled.img `
  height: auto;
  width: 100%;
  max-width: 190px;
  margin: auto;

  @media ${query.lessThanSmall} {
    max-height: 96px;
  }
`;
export const Title = styled(H5) `
  line-height: 28px;

  @media ${query.lessThanMedium} {
    font-size: ${fontSizes.medium}px;
    text-align: center;
  }
`;
export const Description = styled(Body) `
  @media ${query.lessThanSmall} {
    text-align: center;
  }
`;
export const ImageInset = styled(Inset) `
  @media ${query.lessThanMedium} {
    padding-bottom: ${spacing.large}px;
  }
`;
